<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <b-datetimepicker
      :inline="inline"
      :position="position"
      :value="convertedValue"
      :locale="$laravel.app.locale"
      :placeholder="$t('click_or_select_date')"
      icon="calendar-today"
      :class="{'is-danger': hasError()}"
      :append-to-body="appendsToBodyValue"
      :horizontal-time-picker="horizontalTimePicker"
      :timepicker="{
        hourFormat: '24',
        incrementMinutes: incrementMinutes
      }"
      @input="onInput"
    />
  </b-field>
</template>

<script>

import InputBase from "./InputBase";

export default {
  extends: InputBase,
  props: {
    value: {
      required: true,
      validator: prop => typeof prop === "string" || prop === null
    },
    position: {
      type: String,
      default: null
    },
    appendsToBody: {
      default: false,
      type: Boolean
    },
    incrementMinutes: {
      default: 15,
      type: Number
    },
    inline: {
      default: false,
      type: Boolean
    },
    horizontalTimePicker: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    convertedValue () {
      if (this.value !== null) {
        return this.$luxon.fromSQL(this.value).toJSDate();
      }

      return null;
    },
    appendsToBodyValue() {
      if (this.inline == true) {
        return false;
      }

      return this.appendsToBody;
    }
  },
  methods: {
    onInput (payload) {
      if (payload) {
        this.inputListener(this.$luxon.fromJSDate(payload).toFormat("y-LL-dd HH:mm:ss"));
      } else {
        this.inputListener(null);
      }
    }
  }
};
</script>
